import { useBox } from 'shared/hooks/utils';
import { useCallback } from 'react';
import { BoilerAdapter, BoilerAdapterProcessor, BoilerAdapterProtocol } from 'z3k-config';
export const useChangeBoilerAdapterProtocol = (boiler_adapter, builtin_io_extensions_versions, onChange, open) => {
    const boxedBA = useBox(boiler_adapter);
    const onChangeBAType = useCallback((type) => {
        if (type == BoilerAdapterProtocol.BSB) {
            if (boxedBA.current.serial.builtIn) {
                if (builtin_io_extensions_versions.length > 0) {
                    const have_hw_640 = builtin_io_extensions_versions.some(([hw]) => hw === 640);
                    if (have_hw_640) {
                        const have_fw_less_50 = builtin_io_extensions_versions.some(([_, fw]) => fw < 50);
                        if (have_fw_less_50) {
                            open();
                            return;
                        }
                    }
                }
            }
            else {
                if (boxedBA.current.processor == BoilerAdapterProcessor.AT421) {
                    if (BoilerAdapter.getFirmwareVersion(boxedBA.current) < 71) {
                        open();
                        return;
                    }
                }
                else {
                    // we can't check the parameters for builtin adapters
                    if (BoilerAdapter.getFirmwareVersion(boxedBA.current) < 49) {
                        open();
                        return;
                    }
                }
            }
        }
        onChange(type);
    }, [onChange, builtin_io_extensions_versions]);
    return onChangeBAType;
};
